import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export const convertToClasses = (columns) => {
  const {
    mobile = 1,
    mobileLandscape = 1,
    tablet = 1,
    tabletLandscape = 1,
    desktop = 1,
  } = columns;
  const className = `u-1/${mobile} u-1/${
    mobileLandscape
  }@mobile-landscape u-1/${tablet}@tablet u-1/${
    tabletLandscape
  }@tablet-landscape u-1/${desktop}@desktop`;
  return className;
};

const Grid = (props) => {
  const { className, children, columns } = props;
  const gridClassName = convertToClasses(columns);
  return (
    <ol className={cn('o-grid o-grid--gutters-large', className)}>
      {React.Children.map(children, (child, key) => (
        <li key={key} className={cn('o-grid__item', gridClassName)}>
          {child}
        </li>
      ))}
    </ol>
  );
};

export default Grid;

Grid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  columns: PropTypes.shape({
    mobile: PropTypes.number,
    mobileLandscape: PropTypes.number,
    tablet: PropTypes.number,
    tabletLandscape: PropTypes.number,
    desktop: PropTypes.number,
  }),
};

Grid.defaultProps = {
  className: '',
};

Grid.convertToClasses = convertToClasses;
